import React, { Component } from 'react'
import { withStyles } from '@material-ui/styles'
import {
    Box,
    Button,
    TextField,
    Grid
} from '@material-ui/core'
import DropZone from './../components/DropZone'
import {
    CustomSnackBar
} from './../components'
import axios from './../plugins/axios'

const styles = theme => ({
    formControl: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1)
    }
})
class ServiceForm extends Component {

    static defaultProps = {
        name: '',
        description: '',
        image: '',
        enName: '',
        enDescription: ''
    }

    constructor(props) {
        super(props)

        const {
            name,
            description,
            image,
            enName,
            enDescription
        } = props

        this.state = {
            fetching: false,
            disabled: false,
            isSnackOpen: false,
            errors: {},
            name,
            description,
            locale: 'en',
            image,
            enName,
            enDescription
        }
    }

    handleChange = name => e => {
        this.setState({
            [name]: e.target.value
        })
    }

    reset = () => {
        this.setState({
            errors: {},
            name: '',
            description: '',
            image: '',
            enName: '',
            enDescription: ''
        })
    }

    storeOrUpdate = async e => {
        e.preventDefault()
        this.setState({
            errors: {},
            disabled: true
        })

        const {
            path,
            method
        } = this.props

        const {
            name,
            description,
            image,
            locale,
            enName,
            enDescription
        } = this.state

        try {
            await axios[method](path, {
                name,
                description,
                locale,
                image,
                enName,
                enDescription
            })

            this.setState({
                isSnackOpen: true
            })

            if (method === 'post') {
                this.reset()
            }

            this.setState({
                disabled: false
            })
        } catch (err) {
            if (err.response.status === 422) {
                const { errors } = err.response.data
                this.setState({ errors })
            }
        }
    }

    snackClose = () => {
        this.setState({
            isSnackOpen: false
        })
    }

    onChange = (path = '') => {
        this.setState({
            image: path
        })
    }

    render() {
        const {
            name,
            description,
            image,
            enName,
            enDescription,
            errors,
            isSnackOpen
        } = this.state
        const { message } = this.props
        const { formControl } = this.props.classes

        return (
            <div>
                <form
                    onSubmit={this.storeOrUpdate}
                >
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <TextField
                                error={!!errors.name}
                                helperText={errors.name}
                                label="Нэр"
                                value={name}
                                onChange={this.handleChange('name')}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                            />
                            <TextField
                                error={!!errors.description}
                                helperText={errors.description}
                                label="Тайлбар (Хоосон байж болно)"
                                value={description}
                                onChange={this.handleChange('description')}
                                variant="outlined"
                                margin="normal"
                                multiline
                                rows={5}
                                fullWidth
                            />
                            <div className={formControl}>
                                <DropZone
                                    uploadPath="image/upload"
                                    onChange={this.onChange}
                                    file={image}
                                />
                            </div>
                            <Box my={3}>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    type="submit"
                                >
                                    Хадгалах
                                </Button>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                error={!!errors.enName}
                                helperText={errors.enName}
                                label="Нэр"
                                value={enName}
                                onChange={this.handleChange('enName')}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                            />
                            <TextField
                                error={!!errors.enDescription}
                                helperText={errors.enDescription}
                                label="Тайлбар (Хоосон байж болно)"
                                value={enDescription}
                                onChange={this.handleChange('enDescription')}
                                variant="outlined"
                                margin="normal"
                                multiline
                                rows={5}
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                    <CustomSnackBar
                        message={message}
                        open={isSnackOpen}
                        snackClose={this.snackClose}
                    />
                </form>
            </div>
        )
    }
}

export default withStyles(styles)(ServiceForm)
